import React, { useState, useEffect } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  useToaster,
  Message,
  Table,
  SelectPicker
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import WarningRound from '@rsuite/icons/WarningRound';
import { Popconfirm } from 'antd';
import { UserChange } from '@rsuite/icons';
import ReviewPassIcon from '@rsuite/icons/ReviewPass';

interface RowDatacategorydata {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    CategoryName: string;
    ShortName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const CategoryMaster = ({
  label,
  filterDataCata,
  category,
  submit,
  data,
  isLoading,
  editedRowIds,
  editedData,
  setEditedRowIds,
  selectedBuyer,
  searchQuery1,
  handleEditRowCategory,
  handleStatusCCat,
  handleStatusDCat,
  handleInputChange,
  handleBuyerChange,
  handleInputChangeCategory,
  handleSaveRowCategory,
  handleSearch1,
  editedRowId,
  handleCancelCategory,
  processInputRef
}) => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  return (
    <>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={5} className="mstr-panel1">
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>{label[0]?.attributes.Category}</b>
            </Form.ControlLabel>
            <Input
              id="CategoryName"
              name="CategoryName mstr-btn1"
              autoComplete="off"
              ref={processInputRef}
              // style={{ width: '180%' }}
              value={category && category.CategoryName ? category.CategoryName : ''}
              onChange={value => handleInputChange('CategoryName', value, 0)}
              onPressEnter={submit}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Short Name</b>
            </Form.ControlLabel>
            <Input
              id="ShortName"
              name="ShortName mstr-btn1"
              // style={{ width: '180%' }}
              value={category && category.ShortName ? category.ShortName : ''}
              onChange={value => handleInputChange('ShortName', value, 0)}
              onPressEnter={submit}
            />
          </Stack>
          {editedRowId ? (
            <Button appearance="primary" color="cyan" onClick={handleSaveRowCategory} style={{ marginTop: '18px' }}>
              {' '}
              Update
            </Button>
          ) : (
            <Button appearance="primary" color="cyan" onClick={submit} style={{ marginTop: '18px' }}>
              {' '}
              Add
            </Button>
          )}
        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginTop: '16px', marginLeft: '7px' }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyer}
            onChange={handleBuyerChange}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input placeholder="Search" type="text" value={searchQuery1} onChange={handleSearch1} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={filterDataCata}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
        </Table.Column>
        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.Category}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIds.includes(rowData.id) ? (
              //   <Input
              //     value={editedData[rowData.id]?.CategoryName || ''}
              //     onChange={value => handleInputChangeCategory(rowData.id, 'CategoryName', value)}
              //   />
              // ) : (
              rowData.attributes.CategoryName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={200}>
          <Table.HeaderCell>
            <b>Short Name</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIds.includes(rowData.id) ? (
              //   <Input
              //     value={editedData[rowData.id]?.ShortName || ''}
              //     onChange={value => handleInputChangeCategory(rowData.id, 'ShortName', value)}
              //   />
              // ) : (
              rowData.attributes.ShortName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIds.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowCategory(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    style={{ marginRight: '10px' }}
                    onClick={() => handleEditRowCategory(rowData)}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelCategory}
                  />
                </div>
              ) : (
                <div>
                  <Whisper speaker={<Tooltip>Update</Tooltip>}>
                    <IconButton
                      size="sm"
                      icon={<EditIcon />}
                      active
                      onClick={() => handleEditRowCategory(rowData)}
                    />
                  </Whisper>
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Category"
                      description="Are you sure you want to continue this Category?"
                      onConfirm={() => handleStatusCCat(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleStatusCCat(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Category"
                      description="Are you sure you want to discontinue this Category?"
                      onConfirm={() => handleStatusDCat(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPassIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                          // onClick={() => handleStatusDCat(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <p>
        <small>Total row:{filterDataCata.length}</small>
      </p>
    </>
  );
};

export default CategoryMaster;
